export default __webpack_public_path__ + "43f063440ccc5c4d1f59909f231a39b7.svg";